<template>
    <div class="screening-statistics-dialog">
        <dialog-header class="screening-statistics-dialog-header" v-model="headerTitle"
            @close="onDialogClose"></dialog-header>
        <div class="screening-statistics-dialog-content">
            <div class="screening-statistics-dialog-content-information">
                <div class="screening-statistics-dialog-content-information-base-title">
                    <span class="screening-statistics-dialog-content-information-base-title-count">总人次</span>
                    <span class="screening-statistics-dialog-content-information-base-title-task">任务问卷</span>
                    <span class="screening-statistics-dialog-content-information-base-title-time">起止时间</span>
                </div>

                <div class="screening-statistics-dialog-content-information-base-result">
                    <span class="screening-statistics-dialog-content-information-base-result-count">{{ this.personCount
                        }}人</span>
                    <span class="screening-statistics-dialog-content-information-base-result-task">
                        <div class="screening-statistics-dialog-content-information-base-result-task-content">{{
                            this.taskQuestionnaire }}</div>
                        <div class="screening-statistics-dialog-content-information-base-result-task-count">共{{
                            this.taskCount }}个</div>
                    </span>
                    <span class="screening-statistics-dialog-content-information-base-result-time">{{ this.start2endDate
                        }}</span>
                </div>
                <div class="screening-statistics-dialog-content-information-chart">
                    <div class="screening-statistics-dialog-content-information-chart-title">性别统计</div>
                    <div class="screening-statistics-dialog-content-information-chart-sex-chart" ref="sexChart"
                        style="width: 385px;height: 246px;padding: 0;margin: 0;border: 0;margin-left: 8%;"></div>
                </div>
            </div>
            <div class="screening-statistics-dialog-content-age-time">
                <div class="screening-statistics-dialog-content-age-time-age">
                    <div class="screening-statistics-dialog-content-age-time-age-title">年龄分布</div>
                    <div class="screening-statistics-dialog-content-age-time-age-legend">人次</div>
                    <div class="screening-statistics-dialog-content-age-time-age-chart" ref="ageChart"
                        style="width: 438px;height: 216px;padding: 0;margin: 0;border: 0;"></div>
                </div>
                <div class="screening-statistics-dialog-content-age-time-time">
                    <div class="screening-statistics-dialog-content-age-time-time-title">时间统计</div>
                    <div class="screening-statistics-dialog-content-age-time-time-legend">人次</div>
                    <div class="screening-statistics-dialog-content-age-time-time-chart" ref="timeChart"
                        style="width: 468px;height: 216px;padding: 0;margin: 0;border: 0;"></div>
                </div>

            </div>
            <div class="screening-statistics-dialog-content-ahi" v-show="isDepartmentStatTask">
                <div class="screening-statistics-dialog-content-ahi-title">科室统计</div>
                <div class="screening-statistics-dialog-content-ahi-filter">
                    <div class="screening-statistics-dialog-content-ahi-filter-item">
                        <span class="filter-label">时间范围：</span>
                        <el-date-picker
                            class="filter-date-picker"
                            size="mini"
                            v-model="filterDuration"
                            type="daterange"
                            value-format="timestamp"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :default-time="['00:00:00', '23:59:59']"
                        >
                        </el-date-picker>
                    </div>
                    <div class="screening-statistics-dialog-content-ahi-filter-item">
                        <span class="filter-label">科室类型：</span>
                        <el-select
                            v-model="filterVisitType"
                            placeholder="请选择科室类型"
                            size="mini"
                            class="filter-select"
                        >
                            <el-option
                                v-for="item in visitTypeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="screening-statistics-dialog-content-ahi-filter-item">
                        <el-button
                            type="primary"
                            size="mini"
                            class="filter-query-button"
                            @click="onQueryClick"
                        >
                            查询
                        </el-button>
                    </div>
                </div>
                <div class="screening-statistics-dialog-content-ahi-chart" ref="ahiChart"
                    :style="getAhiChartStyle()"></div>
            </div>
        </div>
    </div>
</template>

<script>
import dialogHeader from "@c/screening-questionnaire/screening-dialog/screening-dialog-header.vue"
import * as echarts from 'echarts'
import { DateTool } from "@js/date-tool.js";
import { Select, Option, DatePicker, Button } from "element-ui";
export default {
    props: {
        value: String,
        taskID: Number,
        count: Number,
        visible: Boolean,
    },
    components: {
        dialogHeader,
        ElSelect: Select,
        ElOption: Option,
        ElDatePicker: DatePicker,
        ElButton: Button,
    },
    data() {
        return {
            headerTitle: this.value,
            dialogVisible: this.visibility,
            personCount: '--',
            taskQuestionnaire: '--',
            taskCount: 0,
            start2endDate: null,
            sexChart: null,
            manNum: 0,
            femaleNum: 0,
            ageChart: null,
            ageArray: [],
            ageYmaxValue: 0,
            timeChart: null,
            timeChartScale: 0,
            timeChartxAxisData: [],
            timeChartyAxisData: [],
            timeChartMaxY: 0,
            radius: '0%',
            ahiChart: null,
            ahiData: [],
            filterDuration: null,
            filterVisitType: '',
        };
    },
    computed: {
        isDepartmentStatTask() {
            return [491, 705, 710].includes(Number(this.taskID));
        },
        visitTypeOptions() {
            if (Number(this.taskID) === 710) {
                return [
                    { label: '全部', value: '' },
                    { label: '儿科门诊', value: '儿科门诊' },
                    { label: '儿科病房', value: '儿科病房' }
                ];
            }
            const wardType = Number(this.taskID) === 705 ? '病房' : '住院';
            return [
                { label: '全部', value: '' },
                { label: '门诊', value: '门诊' },
                { label: wardType, value: wardType }
            ];
        }
    },
    methods: {

        onDialogClose(value) {
            this.$emit('close', value);
        },

        refreshStatistics() {
            this.getstatisticalAnalysis();
            if (this.isDepartmentStatTask) {
                this.getDeptStatAnalysis();
            } else {
                this.ahiData = [];
            }
        },

        getAhiChartStyle() {
            return {
                padding: '0',
                margin: '0',
                border: '0'
            };
        },

        initSexChart: function () {
            if (this.femaleNum === 0 && this.manNum === 0) {
                this.radius = '0%'
            } else {
                this.radius = '80%'
            }

            let chartDom = this.$refs.sexChart;

            if (this.sexChart) {
                this.sexChart.clear();
            } else {
                this.sexChart = echarts.init(chartDom);
            }

            const option = {
                backgroundColor: 'transparent',
                title: {
                    show: this.manNum === 0 && this.femaleNum === 0,
                    textStyle: {
                        color: '#ccc',
                        fontSize: 18,
                    },
                    text: "暂无数据",
                    left: "center",
                    top: "center"
                },
                tooltip: {
                    trigger: 'item',
                    formatter: function (params) {

                        if (params.data.name === '女') {
                            return params.marker + params.data.name + '性<br>' + '<div style="text-indent: 1em">' + params.value + '人  ' + params.percent + '%';
                        } else {
                            return params.marker + params.data.name + '性<br>' + '<div style="text-indent: 1em">' + params.value + '人  ' + params.percent + '%';
                        }
                    }
                },
                grid: {
                    show: false,
                    containLabel: true,
                    left: '0%',
                    right: '0%',
                    top: '0%',
                    bottom: '0%'
                },
                series: [
                    {
                        name: '性别',
                        type: 'pie',
                        radius: this.radius,
                        data: [
                            { value: this.femaleNum, name: '女', label: { color: "#F45C50" } },
                            { value: this.manNum, name: '男', label: { color: "#2051BD" } }
                        ],
                        itemStyle: {
                            color: function (params) {
                                if (params.data.name === '女') {
                                    return '#F45C50';
                                } else {
                                    return '#2051BD';
                                }
                            },
                            borderWidth: 0
                        },
                        label: {
                            show: this.femaleNum !== 0 && this.manNum !== 0,
                            formatter: function (params) {
                                if (params.data.name === '女') {
                                    return params.data.name + '性：' + params.value + '人';
                                } else {
                                    return params.data.name + '性：' + params.value + '人';
                                }
                            }
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },
                    }
                ]
            };
            this.sexChart.setOption(option);

        },

        initAgeChart: function () {
            let chartDom = this.$refs.ageChart;

            if (this.ageChart) {
                this.ageChart.clear();
            } else {
                this.ageChart = echarts.init(chartDom);
            }
            const option = {
                dataset: [
                    {
                        dimensions: ['age', 'personNum'],
                        source: this.ageArray
                    },
                    {
                        transform: {
                            type: 'sort',
                            config: { dimension: 'personNum', order: 'desc' }
                        }
                    }
                ],
                title: {
                    show: this.ageArray.length === 0,
                    textStyle: {
                        color: '#ccc',
                        fontSize: 18,
                    },
                    text: "暂无数据",
                    left: "center",
                    top: "center"
                },

                grid: {
                    show: false,
                    containLabel: false,
                    left: '6%',
                    right: '0%',
                    top: '8%',
                    bottom: '10%'
                },
                xAxis: {
                    show: this.ageArray.length != 0,
                    type: 'category',
                    axisLine: {
                        lineStyle: {
                            color: "#000000"
                        }
                    }
                },
                yAxis: {
                    show: this.ageArray.length != 0,
                    max: this.ageYmaxValue,
                    splitLine: { show: false },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#000000"
                        }
                    },
                    axisTick: {
                        show: false
                    },
                },
                series: {
                    type: 'bar',
                    encode: { x: 'age', y: 'personNum' },
                },
                tooltip: {
                    show: true,
                    formatter: (params) => {
                        const xValue = params.name;
                        const yValue = params.value[1];
                        return `数量：${yValue}人次<br/>年龄：${xValue}`;
                    },
                },
            };
            this.ageChart.setOption(option);

        },

        initTimeChart: function () {
            let chartDom = this.$refs.timeChart;

            if (this.timeChart) {
                this.timeChart.clear();
            } else {
                this.timeChart = echarts.init(chartDom);
            }

            const option = {
                color: '#1C53BA',
                title: {
                    show: this.timeChartyAxisData.length === 0,
                    textStyle: {
                        color: '#ccc',
                        fontSize: 18,
                    },
                    text: "暂无数据",
                    left: "center",
                    top: "center"
                },
                xAxis: {
                    show: this.timeChartyAxisData.length != 0,
                    splitLine: { show: false },
                    boundaryGap: false,
                    data: this.timeChartxAxisData,
                    axisLine: {
                        lineStyle: {
                            color: '#262626',
                        }
                    },
                    axisLabel: {
                        showMaxLabel: true,
                        interval: this.timeChartScale,
                        fontSize: 12,
                        showMaxLabel: true,
                        showMinLabel: true,
                        padding: [5, 0, 0, 0],
                        formatter: (value, index) => {
                            if (this.timeChartxAxisData.length > 1) {
                                if (index === 0) {
                                    return '                 ' + value;
                                }
                                if (index === this.timeChartxAxisData.length - 1) {
                                    return value + '                 ';
                                }
                            }
                            return value;
                        }
                    }
                },
                grid: {
                    show: false,
                    containLabel: false,
                    left: '6%',
                    right: '6%',
                    top: '8%',
                    bottom: '11%'
                },
                yAxis: {
                    show: this.timeChartyAxisData.length != 0,
                    axisTick: { show: true },
                    max: this.timeChartMaxY,
                    splitLine: { show: false },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#262626',
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        fontSize: 12,
                    }
                },
                tooltip: {
                    show: this.timeChartyAxisData.length != 0,
                    trigger: 'axis',
                    formatter: function (params) {
                        var value = params[0].value;
                        var date = params[0].axisValue;
                        return '数量：' + value + '人次' + '<br>' + '日期：' + date;
                    },
                    textStyle: {
                        color: '#2051BD',
                        fontSize: 12
                    },
                },
                series: [
                    {
                        name: '人次',
                        type: 'line',
                        data: this.timeChartyAxisData,
                        symbol: 'none',
                        itemStyle: {
                            color: '#2051BD',
                            borderWidth: 2,
                            borderColor: '#2051BD'
                        },
                        label: {
                            show: false,
                            position: 'top'
                        }
                    }
                ]
            };
            this.timeChart.setOption(option);
        },

        initAhiChart: function () {
            let chartDom = this.$refs.ahiChart;

            if (this.ahiChart) {
                this.ahiChart.clear();
            } else {
                this.ahiChart = echarts.init(chartDom);
            }

            const dates = this.ahiData.map(item => item.keyName);
            
            let barWidth = '60%';
            if (this.ahiData.length <= 2) {
                barWidth = '60px';
            } else if (this.ahiData.length <= 4) {
                barWidth = '80px';
            } else if (this.ahiData.length <= 6) {
                barWidth = '60px';
            }

            const option = {
                backgroundColor: 'transparent',
                title: {
                    show: this.ahiData.length === 0,
                    textStyle: {
                        color: '#ccc',
                        fontSize: 18,
                    },
                    text: "暂无数据",
                    left: "center",
                    top: "center"
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter: function (params) {
                        let result = params[0].axisValue + '<br>';
                        params.forEach(function (item) {
                            if (item.value > 0) {
                                result += item.marker + item.seriesName + ': ' + item.value + '人<br>';
                            }
                        });
                        return result;
                    }
                },
                legend: {
                    data: ['轻危', '中危', '高危'],
                    top: 10,
                    right: 20,
                    itemGap: 20,
                    textStyle: {
                        color: '#333',
                        fontSize: 12
                    },
                    icon: 'rect',
                    itemWidth: 14,
                    itemHeight: 14
                },
                grid: {
                    left: this.ahiData.length <= 2 ? '3%' : '2%',
                    right: this.ahiData.length <= 2 ? '5%' : '3%',
                    bottom: '8%',
                    top: '15%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: dates,
                        axisTick: {
                            alignWithLabel: true
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#333'
                            }
                        },
                        axisLabel: {
                            color: '#333',
                            fontSize: 12
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '人数',
                        nameTextStyle: {
                            color: '#333',
                            fontSize: 12
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#333'
                            }
                        },
                        axisLabel: {
                            color: '#333',
                            fontSize: 12
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#eee'
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: '轻危',
                        type: 'bar',
                        stack: 'AHI',
                        barWidth: barWidth,
                        data: this.ahiData.map(item => item.mildNum || 0),
                        itemStyle: {
                            color: '#2196F3'
                        }
                    },
                    {
                        name: '中危',
                        type: 'bar',
                        stack: 'AHI',
                        barWidth: barWidth,
                        data: this.ahiData.map(item => item.moderateNum || 0),
                        itemStyle: {
                            color: '#FF9800'
                        }
                    },
                    {
                        name: '高危',
                        type: 'bar',
                        stack: 'AHI',
                        barWidth: barWidth,
                        data: this.ahiData.map(item => item.severeNum || 0),
                        itemStyle: {
                            color: '#F44336'
                        }
                    }
                ]
            };

            this.ahiChart.setOption(option);
        },

        async getstatisticalAnalysis() {
            this.manNum = 0
            this.femaleNum = 0
            const params = {
                "id": this.taskID,
            };
            try {
                const data = await this.$api.getstatisticalAnalysis(params);
                this.personCount = data.num
                this.taskQuestionnaire = data.taskQuestionnaire.join(',');
                if (this.taskQuestionnaire.length > 58) {
                    this.taskQuestionnaire = this.taskQuestionnaire.slice(0, 58) + '...';
                };
                this.taskCount = data.taskQuestionnaire.length;
                this.start2endDate = data.startTime + '~' + data.endTime;

                this.ageArray = [];

                // 修复性别统计数据处理
                if (data.genderStatistical !== null && Array.isArray(data.genderStatistical) && data.genderStatistical.length > 0) {
                    // 遍历性别统计数据，而不是假设数组结构
                    data.genderStatistical.forEach(item => {
                        if (item.keyName === '男') {
                            this.manNum = item.num;
                        } else if (item.keyName === '女') {
                            this.femaleNum = item.num;
                        }
                    });
                }

                let max = 0;
                if (data.ageDistribution !== null && Array.isArray(data.ageDistribution)) {
                    data.ageDistribution.forEach(item => {
                        if (item.num > max) {
                            max = item.num;
                        }
                    });
                }

                if (max <= 10) {
                    this.ageYmaxValue = 10;
                } else {
                    this.ageYmaxValue = Math.ceil(max / 10) * 10;
                }

                if (data.ageDistribution !== null && Array.isArray(data.ageDistribution)) {
                    this.ageArray = data.ageDistribution.map(item => [item.keyName + '岁', item.num]);
                }

                this.timeChartxAxisData = []
                this.timeChartyAxisData = []

                if (data.timeStatistics !== null && Array.isArray(data.timeStatistics)) {
                    for (const timeStatistic of data.timeStatistics) {
                        this.timeChartyAxisData.push(timeStatistic.num);
                    }
                }

                // 修复时间统计最大值计算
                const timeChartMaxNum = this.timeChartyAxisData.length > 0 ? Math.max(...this.timeChartyAxisData) : 0;
                let timeChartMaxY = 0;
                if (timeChartMaxNum === 0) {
                    timeChartMaxY = 10;
                } else {
                    timeChartMaxY = Math.ceil(timeChartMaxNum / 10) * 10;
                    if (timeChartMaxY === timeChartMaxNum) {
                        timeChartMaxY += 10;
                    }
                }
                this.timeChartMaxY = timeChartMaxY;
                const endTime = new Date(data.endTime.replace(/年|月/g, '/').replace(/日/g, ''));
                const startTime = new Date(data.startTime.replace(/年|月/g, '/').replace(/日/g, ''));
                const diffDays = (endTime.getTime() - startTime.getTime()) / (1000 * 60 * 60 * 24) + 1;
                const startTimeTemp = startTime.getTime() / 1000

                if (diffDays > 1) {
                    for (let i = 0; i <= diffDays - 1; i++) {
                        const date = DateTool.timestampToStr(startTimeTemp + i * 24 * 60 * 60, "Y-M-D");
                        this.timeChartxAxisData.push(date);
                    }
                    if (diffDays > 2) {
                        this.timeChartScale = diffDays - 2
                    } else {
                        this.timeChartScale = 1
                    }
                } else {
                    const date = DateTool.timestampToStr(startTimeTemp, "Y-M-D");
                    this.timeChartxAxisData.push(date);
                }

                this.initSexChart();
                this.initAgeChart();
                this.initTimeChart();
                this.initAhiChart();

            } catch (error) {
                this.$toast.showRed(error);
            }
        },

        async getDeptStatAnalysis() {
            const formatTimestamp = (timestamp) => {
                const date = new Date(timestamp);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            };

            const params = {
                "deptName": Number(this.taskID) === 710 ? this.filterVisitType : "",
                "endTime": this.filterDuration && this.filterDuration.length > 1 ? formatTimestamp(this.filterDuration[1]) : "",
                "id": this.taskID,
                "startTime": this.filterDuration && this.filterDuration.length > 0 ? formatTimestamp(this.filterDuration[0]) : "",
                "visitType": Number(this.taskID) === 710 ? "" : this.filterVisitType
            }
            
            try {
                const data = await this.$api.getDeptStatAnalysis(params);
                
                if (data && Array.isArray(data)) {
                    this.ahiData = data;
                } else {
                    this.ahiData = [];
                }
                
                this.initAhiChart();
                
                this.$nextTick(() => {
                    if (this.ahiChart) {
                        this.ahiChart.resize();
                    }
                });

            } catch (error) {
                this.$toast.showRed(error);
                this.ahiData = [];
                this.initAhiChart();
                
                this.$nextTick(() => {
                    if (this.ahiChart) {
                        this.ahiChart.resize();
                    }
                });
            }
        },

        onQueryClick() {
            this.getDeptStatAnalysis();
        }

    },

    watch: {
        taskID(newVal) {
            this.filterVisitType = '';
            this.ahiData = [];
            if (!this.visible) {
                return;
            }
            this.refreshStatistics();
        },
        visible(newVal) {
            if (!newVal) {
                return;
            }
            this.$nextTick(() => {
                this.refreshStatistics();
            });
        },
        count(newVal) {
            if (!this.visible) {
                return;
            }
            this.getstatisticalAnalysis();
        }
    },
    mounted() {
        if (this.visible) {
            this.refreshStatistics();
        }
    },

}


</script>

<style lang="scss" scoped>
@import "@css/style.scss";

.screening-statistics-dialog {
    width: 100%;
    min-width: rem(976);
    min-height: rem(800);
    height: auto;

    display: flex;
    flex-direction: column;

    background: #FFFFFF;

    border-radius: 2px;

    &-header {
        width: 100%;
        height: rem(57);
    }

    &-content {
        display: flex;
        flex-direction: column;
        padding: rem(20) rem(0) rem(20) rem(45);
        flex: 1;
        min-height: 0;

        &-information {
            display: flex;
            position: relative;

            &-base-title {
                font-size: rem(14);
                color: #888888;
                font-weight: 400;
                display: flex;
                flex-direction: column;

                &-task {
                    margin-top: rem(40);

                }

                &-time {
                    margin-top: rem(40);
                }
            }

            &-base-result {
                margin-left: rem(20);
                font-size: rem(14);
                font-weight: 400;
                color: black;
                display: flex;
                flex-direction: column;

                &-task {
                    margin-top: rem(40);
                    display: flex;

                    &-content {
                        max-width: rem(336);
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }

                &-time {
                    margin-top: rem(40);
                }

            }

            &-chart {
                position: absolute;
                margin-left: 51%;

                font-size: rem(16);
                font-weight: 400;
                color: black;
            }
        }

        &-age-time {
            margin-top: rem(138);
            font-size: rem(16);
            color: black;
            font-weight: 400;
            display: flex;
            position: relative;

            &-age {
                display: flex;
                flex-direction: column;

                &-legend {

                    margin-top: rem(10);
                    font-size: rem(12);
                    color: black;
                }
            }

            &-time {
                position: absolute;
                margin-left: 51%;

                display: flex;
                flex-direction: column;

                &-legend {

                    margin-top: rem(10);
                    font-size: rem(12);
                    color: black;
                }
            }
        }

        &-ahi {
            margin-top: rem(40);
            font-size: rem(16);
            color: black;
            font-weight: 400;
            display: flex;
            flex-direction: column;
            position: relative;
            width: 100%;
            z-index: 10;
            margin-left: rem(0);

            &-title {
                font-size: rem(16);
                color: black;
                font-weight: 400;
                margin-bottom: rem(5);
                margin-left: rem(0);
            }

            &-legend {
                margin-top: rem(10);
                margin-bottom: rem(10);
                font-size: rem(12);
                color: black;
                margin-left: rem(0);
            }

            &-filter {
                display: flex;
                align-items: center;
                margin: rem(15) rem(25) rem(20) 0;
                padding: rem(12) rem(15);
                gap: rem(20);
                background-color: #f8f9fa;
                border-radius: rem(4);
                border: 1px solid #e8e8e8;
                position: relative;
                z-index: 11;
                width: calc(100% - rem(45));
                max-width: rem(1050);
                box-sizing: border-box;
                margin-left: rem(0);

                &-item {
                    display: flex;
                    align-items: center;
                    
                    .filter-label {
                        font-size: rem(14);
                        color: #333;
                        margin-right: rem(8);
                        white-space: nowrap;
                        font-weight: 500;
                    }

                    .filter-date-picker {
                        width: rem(280);
                        min-width: rem(200);
                    }

                    .filter-select {
                        width: rem(120);
                        min-width: rem(100);
                    }

                    .filter-query-button {
                        width: rem(80);
                        height: rem(32);
                        flex-shrink: 0;
                    }
                }
            }

            &-chart {
                margin-top: rem(10);
                position: relative;
                z-index: 1;
                width: calc(100% - rem(45));
                max-width: rem(1050);
                height: rem(300);
                clear: both;
                margin-left: rem(0);
            }
        }

    }
}
</style>
